var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSelectOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1185",
    transform: "translate(-30 -452)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 226",
    width: 24,
    height: 24,
    rx: 5,
    transform: "translate(30 452)",
    style: {
      fill: "#00a61c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 182",
    d: "M6.465 10.276a1.99 1.99 0 0 1-1.411-.584L.584 5.22A1.994 1.994 0 0 1 3.4 2.4l3.065 3.06 6.875-6.875a1.993 1.993 0 0 1 2.82 0 1.993 1.993 0 0 1 0 2.82L7.876 9.692a1.99 1.99 0 0 1-1.411.584",
    transform: "translate(33.627 459.863)",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSelectOn);
export default __webpack_public_path__ + "static/media/ic-select-on.321f487e23f33549d907cb357e65d84f.svg";
export { ForwardRef as ReactComponent };